module.exports = __webpack_public_path__ + "static/media/fornitori_gare_appalto.dbbe7e49.md";